import React, {Component} from 'react';
import {Link} from "react-router-dom";


class Organization extends Component {
    constructor(props) {
        super(props);

        this.state = {
            organizationId: props.match.params.organizationId,
            err: null
        };
    }

    componentDidMount() {
        if (this.state.organizationId.startsWith("demo")) {
            fetch('/' + this.state.organizationId + '/organizationWithOperations.json')
                .then(response => response.json())
                .then(data => this.setState({data}));
        } else {
            fetch('/organizationWithOperations?id=' + this.state.organizationId, {
                headers: { 'Authorization': this.props.token }
            })
                .then(response => response.json())
                .then(data => {
                    this.setState({err: data.err});
                    if (!data.err) {
                        this.setState({data});
                    }
                });
        }
    }

    render() {
        if(this.state.err){
            return <h1>{this.state.err}</h1>;
        } else if(this.props.token === "" && !this.state.organizationId.startsWith("demo")) {
            return <p>Missing token</p>;
        } else if (!this.state.data) {
            return <div></div>
        } else if (this.state.data.err) {
            return <p>{this.state.data.err}</p>
        } else {
            return (
                <div>
                    <div className="container grid-lg">
                        <div className="columns m-2">
                            <div className="column col-12">
                                <h2>{this.state.data.name}</h2>
                                <ul>
                                    {this.state.data.operations.map(operation => {
                                        return (
                                            <li key={operation.id}>
                                                <Link to={"/operation/" + operation.id}>{operation.name}</Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default Organization;
